<div class="row">
  <div class="col-6">
    <div class="info-container">

      <div class="title" [innerHTML]="'Documents.Passport.Help.BiometricTitle' | translate | safe:'html'">
      </div>

      <img src="/img/biometric-passport-example.png" alt="biometric passport example">

    </div>

  </div>
  <div class="col-6">
    <div class="info-container">

      <div class="title" [innerHTML]="'Documents.Passport.Help.NonBiometricTitle' | translate | safe:'html'">
      </div>

      <img src="/img/non-biometric-passport-example.png" alt="non biometric passport">

    </div>

  </div>
</div>

<div class="info-container">

  <ul>
    <li [innerHTML]="'Documents.Passport.Help.File' | translate | safe:'html'"></li>
    <li [innerHTML]="'Documents.Passport.Help.Signed' | translate | safe:'html'"></li>
    <li [innerHTML]="'Documents.Passport.Help.Valid' | translate | safe:'html'"></li>
    <li [innerHTML]="'Documents.Passport.Help.Filled' | translate | safe:'html'"></li>
  </ul>

</div>
